import { defineMessages } from 'react-intl';
export default defineMessages({
	poweredBy: {
		id: 'comp.footer.poweredBy',
		defaultMessage: 'powered by',
	},
});
